import { render } from "./TeamPointsCardV2.vue?vue&type=template&id=2d2118f0&scoped=true"
import script from "./TeamPointsCardV2.vue?vue&type=script&lang=js"
export * from "./TeamPointsCardV2.vue?vue&type=script&lang=js"

import "./TeamPointsCardV2.vue?vue&type=style&index=0&id=2d2118f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2118f0"]])

export default __exports__